import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const MemberCtx = createContext({ member: null, loading: true, refresh: () => {}, logout: () => {} });

export const MemberProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try { const r = await api.get("/portal/me"); setMember(r.data); }
    catch { setMember(null); }
    finally { setLoading(false); }
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/portal/logout"); } catch (e) {
      if (process.env.NODE_ENV === "development") console.warn("[member] logout request failed; clearing local state anyway", e);
    }
    setMember(null);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false); return;
    }
    refresh();
  }, [refresh]);

  return <MemberCtx.Provider value={{ member, loading, refresh, logout }}>{children}</MemberCtx.Provider>;
};

export const useMember = () => useContext(MemberCtx);
